<script>
  import Menu from "../components/Menu.svelte";
  import Breadcrumbs from "../components/Breadcrumbs.svelte";
  import Footer from "../components/Footer.svelte";
  import AcceptCancelDialog from "../components/AcceptCancelDialog.svelte";
  import EmailDialog from "../components/EmailDialog.svelte";
  import UserItem from "../components/UserItem.svelte";

  import { dictionary } from "../utils/stores.js";
  import { getToken, redirectIfNotToken } from "../utils/token.js";
  import { post } from "../utils/api.js";

  import { onMount } from "svelte";
  import { sendEmail } from "../utils/email";

  redirectIfNotToken("/login");

  let dict;

  const unsubscribe = dictionary.subscribe((value) => {
    dict = value;
  });

  const pageName = "opciones";
  let filtro = "todos";

  let usuarios = [];
  let removeUserPos = -1;

  let sendEmailEmail = "";
  let sendEmailSubject = "";
  let sendEmailBody = "";
  let sendEmailAdjuntos = [];
  let sendEmailOnSent = null;
  let sendEmailBeforeSend = null;

  onMount(async () => {
    listarUsuarios();
  });

  let listarUsuarios = async () => {
    const response = await post(
      "Usuarios",
      {
        token: getToken(),
      },
      "json"
    );
    usuarios = response.map((item) => {
      return {
        id: item.id,
        email: item.email,
        nombre: item.nombreUsuario,
        apellido1: item.apellido1Usuario,
        apellido2: item.apellido2Usuario,
        apellido1: item.apellido1Usuario,
        institucion: item.institucionUsuario,
        firma: item.firmaUsuario,
        rol: item.rol,
        esRevisor: item.esRevisor,
        soyYo: item.soyYo,
      };
    });
  };

  let changeRole = (id) => {
    let user = usuarios.find((item) => {
      return item.id === id;
    });
    post(
      "CambiarRolUsuario",
      {
        token: getToken(),
        id: user.id,
        rol: user.rol,
      },
      ""
    );
  };

  let editUser = (id) => {
    window.open("/cuenta/" + id + "/", "_blank");
  };

  let logEditor = (id) => {
    window.open("/historial-editor/" + id + "/", "_blank");
  };

  let logReviewer = (id) => {
    window.open("/historial-revisor/" + id + "/", "_blank");
  };

  let removeUser = () => {
    post(
      "EliminarUsuario",
      {
        token: getToken(),
        user: usuarios[removeUserPos].id,
      },
      ""
    );
    usuarios.splice(removeUserPos, 1);
    usuarios = usuarios;
    window.$("#removeUser").modal("hide");
  };

  let emailUser = (id) => {
    const user = usuarios.find((item) => {
      return item.id === id;
    });
    if (user) {
      sendEmailEmail = [user.email];
      sendEmailSubject = "Correo desde plataforma";
      sendEmailBody = "";
      sendEmailOnSent = emailSent;
      sendEmailBeforeSend = null;
      sendEmailAdjuntos = [];

      window.$("#sendEmail").modal("show");
    }
  };

  let emailSent = () => {
    window.$("#sendEmail").modal("hide");
  };
</script>

<style>
  div.filtros {
    margin-top: 40px;
  }

  div.filtros span {
    margin-right: 10px;
  }

  table.usuarios {
    margin-top: 40px;
    margin-bottom: 20px;
  }
</style>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">
  <!-- Menu -->

  <Menu {pageName} />

  <!-- Breadcrumbs -->

  <Breadcrumbs pageName={dict[pageName]} />

  <!-- Body -->

  <section class="section">
    <div class="container">
      <h3 class="titulo">{dict['usuarios']}</h3>
      <div class="filtros">
        <span>Filtrar:</span>
        <select bind:value={filtro}>
          <option value="todos">Todos</option>
          <option value="editoresJefe">Editores Jefe</option>
          <option value="editores">Editores</option>
          <option value="revisores">Revisores</option>
          <option value="autores">Autores</option>
        </select>
      </div>
      <table class="usuarios">
        {#each usuarios as user, index}
          {#if filtro === 'todos' || (filtro === 'editoresJefe' && user.rol === 'EditorJefe') || (filtro === 'editores' && user.rol === 'Editor') || (filtro === 'revisores' && user.esRevisor) || (filtro === 'autores' && user.rol === 'Usuario')}
            <UserItem
              {user}
              onEdit={() => editUser(user.id)}
              onLogEditor={() => logEditor(user.id)}
              onLogReviewer={() => logReviewer(user.id)}
              onRemove={() => {
                removeUserPos = index;
                window.$('#removeUser').modal('show');
              }}
              onChangeRole={() => changeRole(user.id)}
              onEmail={() => emailUser(user.id)} />
          {/if}
        {/each}
      </table>
    </div>
  </section>
  <Footer />
</div>
<div class="snackbars" id="form-output-global" />
<AcceptCancelDialog
  id="removeUser"
  titulo={dict['eliminarUsuario']}
  tituloAceptar={dict['eliminar']}
  tituloCancelar={dict['cancelar']}
  aceptarAction={() => removeUser()}
  text={dict['preguntaEliminarUsuario']} />
<EmailDialog
  id="sendEmail"
  email={sendEmailEmail}
  subject={sendEmailSubject}
  bind:body={sendEmailBody}
  attached={sendEmailAdjuntos}
  beforeSend={sendEmailBeforeSend}
  onSent={sendEmailOnSent} />
